import { makeOAuthRequest } from "../api/cPanel";
import { useModalContext } from "../contexts/modal";

const DIALOG_ID = "login";

const useLogin = () => {
  const { showConfirm, hideDialog, checkDialogId } = useModalContext();

  const openLoginWindow = (onAuthWindowClose) => {
    const authWindow = makeOAuthRequest();

    const checkIfWindowAuthClosed = () => {
      if (authWindow?.closed) {
        clearInterval(timer);

        if (onAuthWindowClose) {
          onAuthWindowClose();
        }

        if (checkDialogId(DIALOG_ID)) {
          hideDialog();
        }
      }
    };

    const timer = setInterval(checkIfWindowAuthClosed, 500);
  };

  const showLoginConfirm = (onCancel, onConfirm) => {
    const handleConfirm = () => {
      openLoginWindow();

      if (onConfirm) {
        onConfirm();
      }
    };

    showConfirm(
      "pleaseSignIn",
      "enterToUse",
      handleConfirm,
      {
        dialogId: DIALOG_ID,
        translateMessage: true,
        positiveBtn: "signIn",
        onCancel: (...args) => {
          if (onCancel) {
            onCancel(...args);
          }

          return true; // to auto-close the modal
        },
      },
    );
  };

  return {
    openLoginWindow,
    showLoginConfirm,
  };
};

export default useLogin;
